import { LOADING_STATUS } from './data';

// Auth
export const SIGN_IN = 'SIGN_IN';
export const SIGN_UP = 'SIGN_UP';
export const SIGN_OUT = 'SIGN_OUT';
export const FORGOT_PASSWORD = 'FORGOT_PASSWORD';
export const SET_USER_AVATAR = 'SET_USER_AVATAR';
export const UPDATE_USER_INFO = 'UPDATE_USER_INFO';
export const SIGN_IN_LOADING_STATUS = `${SIGN_IN}_${LOADING_STATUS}`;
export const SIGN_UP_LOADING_STATUS = `${SIGN_UP}_${LOADING_STATUS}`;

// Popup
export const OPEN_POPUP = 'OPEN_POPUP';
export const CLOSE_POPUP = 'CLOSE_POPUP';

// Dialog
export const OPEN_DIALOG = 'OPEN_DIALOG';
export const CLOSE_DIALOG = 'CLOSE_DIALOG';

// Toaster
export const OPEN_TOASTER = 'OPEN_TOASTER';
export const CLOSE_TOASTER = 'CLOSE_TOASTER';

// Teams
export const CREATE_TEAM = 'CREATE_TEAM';
export const GET_ALL_TEAMS = 'GET_ALL_TEAMS';
export const GET_TEAM_INFO = 'GET_TEAM_INFO';
export const SET_TEAM_AVATAR = 'SET_TEAM_AVATAR';
export const UPDATE_TEAM_INFO = 'UPDATE_TEAM_INFO';
export const JOIN_TEAM_REQUEST = 'JOIN_TEAM_REQUEST';
export const SET_TEAM_HEADER_IMAGE = 'SET_TEAM_HEADER_IMAGE';
export const GET_TEAM_INVITATION_CODE = 'GET_TEAM_INVITATION_CODE';
export const CREATE_TEAM_LOADING_STATUS = `${CREATE_TEAM}_${LOADING_STATUS}`;
export const GET_ALL_TEAMS_LOADING_STATUS = `${GET_ALL_TEAMS}_${LOADING_STATUS}`;
export const GET_TEAM_INFO_LOADING_STATUS = `${GET_TEAM_INFO}_${LOADING_STATUS}`;
export const UPDATE_TEAM_INFO_LOADING_STATUS = `${UPDATE_TEAM_INFO}_${LOADING_STATUS}`;
export const JOIN_TEAM_REQUEST_LOADING_STATUS = `${JOIN_TEAM_REQUEST}_${LOADING_STATUS}`;
export const GET_TEAM_INVITATION_CODE_LOADING_STATUS = `${GET_TEAM_INVITATION_CODE}_${LOADING_STATUS}`;

// Avatar
export const SET_AVATAR = 'SET_AVATAR';
export const AVATARS_REQUEST = 'AVATARS_REQUEST';
export const AVATARS_SUCCESS = 'AVATARS_SUCCESS';

// Clubs
export const GET_CLUBS = 'GET_CLUBS';
export const CREATE_CLUB = 'CREATE_CLUB';
export const GET_CLUBS_LOADING_STATUS = `${GET_CLUBS}_${LOADING_STATUS}`;

// National Federation
export const GET_MEMBERS = 'GET_MEMBERS';

//LeaderBoard
export const GET_TOURNAMENTS_LIST = 'GET_TOURNAMENTS_LIST';
export const GET_TEAM_LEADERBOARD = 'GET_TEAM_LEADERBOARD';
export const GET_PLAYER_LEADERBOARD = 'GET_PLAYER_LEADERBOARD';

//Matches
export const GET_MATCHES = 'GET_MATCHES';
export const JOIN_MATCH = 'JOIN_MATCH';
export const START_MATCH = 'START_MATCH';
export const GET_LIVE_MATCHES = 'GET_LIVE_MATCHES';
export const GET_UPCOMING_MATCHES = 'GET_UPCOMING_MATCHES';
export const GET_ARCHIVED_MATCHES = 'GET_ARCHIVED_MATCHES';
export const GET_MATCH_PLAYERS = 'GET_MATCH_PLAYERS';
export const GET_MATCH_SESSIONS = 'GET_MATCH_SESSIONS';
export const GET_SESSION_SEAT_DRAW = 'GET_SESSION_SEAT_DRAW';
export const GET_PUBLIC_INFO = 'GET_PUBLIC_INFO';
export const CREATE_MATCH = 'CREATE_MATCH';
